export default "__VITE_ASSET__Dpg_znLc__"